var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-fields" },
    [
      _c(
        "draggable",
        {
          attrs: { disabled: false },
          on: { update: _vm.taskSortHandler },
          model: {
            value: _vm.taskOrder,
            callback: function($$v) {
              _vm.taskOrder = $$v
            },
            expression: "taskOrder"
          }
        },
        [
          _vm._l(_vm.tasks, function(task, index) {
            return _c(
              "div",
              {
                key: "task" + index,
                staticClass: "d-flex flex-row field-block",
                class: _vm.getClassForTaskField(task)
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "field-control-wrapper field-control-wrapper__title",
                    class: { "no-radius": index != _vm.tasks.length - 1 }
                  },
                  [
                    _c("TaskTitle", {
                      attrs: {
                        fullDeliverables: _vm.fullDeliverables,
                        deliverableId: _vm.deliverableId,
                        deliverable: _vm.deliverable,
                        totalTasks: _vm.tasks.length,
                        task: task,
                        index: index,
                        namespace: _vm.namespace
                      },
                      on: { toggleTaskFields: _vm.showTaskFields }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(task.taskFields, function(taskField, index1) {
                  return _c(
                    "div",
                    {
                      key: "taskField" + index1,
                      staticClass: "d-none d-lg-block field-rows",
                      class:
                        _vm.getClasses(taskField) +
                        " toggleTaskField__" +
                        task.id
                    },
                    [
                      _c("CustomFields", {
                        attrs: {
                          fullDeliverables: _vm.fullDeliverables,
                          sortEnabledFields: [
                            "status",
                            "status_note",
                            "user",
                            "due_date",
                            "request"
                          ],
                          taskCount: _vm.tasks.length,
                          multipleTasks: index == 0,
                          deliverable: _vm.deliverable,
                          users: _vm.users,
                          customField: taskField,
                          rows: 1,
                          namespace: _vm.namespace,
                          task: task,
                          isTaskAssignedToLoggedInUser: _vm.isTaskAssignedToLoggedInUser(
                            task
                          ),
                          disabled:
                            taskField.field_type == "datepicker" ? true : false
                        }
                      })
                    ],
                    1
                  )
                })
              ],
              2
            )
          }),
          _vm._v(" "),
          _c("AdditionalFields", {
            attrs: {
              deliverableType: _vm.deliverable.deliverable_template_id,
              deliverableId: _vm.deliverableId,
              namespace: _vm.namespace
            }
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }